import mensajeError  from "../../mensajes/MensajeError";

/**
 * Realiza petición GET de la API para obtener catálogo correspondiente al endpoint
 * @param {String} endpoint 
 * @param {String} mensaje 
 * @param {Number} tiempo 
 * @returns Lista de catálogos
 */
export const obtenerCatalogo = async (endpoint, mensaje, tiempo) => {
    try {
        const data = await (await fetch(endpoint)).json();
        return [...data.data];
    }
    catch (error) {
        if(error instanceof TypeError){
            try {
                const data = await (await fetch(endpoint)).json();
                return {...data.data};
            }
            catch (_) {
                mensajeError(mensaje, tiempo);
                return {};
            }
        }
        else{
            mensajeError(mensaje, tiempo);
            return [];
        }
    }
}

/* "/api/uma/lista") */